import React from "react";

function Colored({ children, color }) {
  // set opacity to 0x20/0x100 for background
  const style = { "--color": color, "--bg-color": `${color}20` };
  return <div style={style}>{children}</div>;
}

export default Colored;
